// import { FaArrowRightLong } from "react-icons/fa6";
import passport from "./Assets/images/passportImg.jpg"
import visa from "./Assets/images/visaImg.jpg"
import docoment from "./Assets/images/docoment.jpg"
import certificates from "./Assets/images/certificates.jpg"
import registration from "./Assets/images/registration.jpg"
import travel from "./Assets/images/travel.jpg"
import auscity from "./Assets/city/auscity.jpg"
import ukcity from "./Assets/city/englandcity.jpg"
import canadacity from "./Assets/city/canadacity.jpg"
import usacity from "./Assets/city/usa.webp"
import workpermit from "./Assets/images/workpermit.jpg"
import airticket from "./Assets/images/air-ticket.jpg"
import immigration from "./Assets/images/immigration.jpg"



export const exploreServices = [
    {
        id: 1,
        title: "Passport services",
        img: passport,
        desc: "Efficient passport services to simplify your international travel plans!"
    },
    {
        id: 2,
        title: "Visa services",
        img: visa,
        desc: "Expert visa services for a seamless journey to your desired destination!"
    },
    {
        id: 3,
        title: "Identity & certi Services",
        img: docoment,
        desc: "Trusted services for identity verification and certification needs"
    },
    {
        id: 4,
        title: "Government Docs Assistance",
        img: certificates,
        desc: "Assistance for making government documentation"
    },
    {
        id: 5,
        title: "MSME Registration",
        img: registration,
        desc: "Easy MSME registration to help your business grow and thrive!"
    },
    {
        id: 6,
        title: "Travel Assistance",
        img: travel,
        desc: "Comprehensive travel assistance for a smooth and worry-free journey to your destination!"
    }
]

export const explorecountries = [
    {
        id: 1,
        title: "Australia",
        img: auscity,
        desc: "Efficient passport services to simplify your international travel plans!"
    },
    {
        id: 2,
        title: "United-kingdom",
        img: ukcity,
        desc: "Expert visa services for a seamless journey to your desired destination!"
    },
    {
        id: 3,
        title: "Canada",
        img: canadacity,
        desc: "Trusted services for identity verification and certification needs"
    },
    {
        id: 4,
        title: "USA",
        img: usacity,
        desc: "Assistance for making government documentation"
    }

]


export const exploreS3 = [
    {
        id: 1,
        title: "Work Permit",
        img: workpermit,
        desc: "Effortless work permit solutions, unlocking global career possibilities"
    },
    {
        id: 2,
        title: "Air ticket",
        img: airticket,
        desc: "Book your air tickets effortlessly for a smooth and convenient journey"
    },
    {
        id: 3,
        title: "Immigration",
        img: immigration,
        desc: "Seamless immigration services to help you start your new chapter abroad"
    }

]

